module.exports = __webpack_public_path__ + "static/media/marker_bubble_drag.d8c33c47.svg";